// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"4104479e","70":"d0a57236","71":"9a144e85","195":"26090970","293":"f0a7292c","349":"34ccb815","360":"a531cd56","419":"3e317f67","606":"530f9a02","621":"511bcc34","870":"65de06e9"}[chunkId] + ".chunk.js";
};